/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const USD = 'USD';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const EUR = 'EUR';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const GBP = 'GBP';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const AUD = 'AUD';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const JPY = 'JPY';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const SGD = 'SGD';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const COP = 'COP';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const CAD = 'CAD';
/** @deprecated Use AVAILABLE_CURRENCY_CODES from growth-monetization-service-types instead. */
export const INR = 'INR';